var map = {
	"./icon-carret-down-thin.svg": "./svg/icon-carret-down-thin.svg",
	"./icon-carret-down.svg": "./svg/icon-carret-down.svg",
	"./icon-chevron-left.svg": "./svg/icon-chevron-left.svg",
	"./icon-chevron-right.svg": "./svg/icon-chevron-right.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";